module.exports = __webpack_public_path__ + "media/images/emblems/Vallon-coat_of_arms-1a8a32cba90a6e01e0a4a7ba9f3a1f4e.svg";